// utils/device.js
export default {
  isMobile: () => {
    const userAgent = navigator.userAgent.toLowerCase()
    // let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return /android|webos|iphone|ipad|ipod|blackberry|windows phone|mobile/i.test(userAgent)
  },

  isIOS: () => {
    return /iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase())
  },

  isAndroid: () => {
    return /android/i.test(navigator.userAgent.toLowerCase())
  },

  isWeChat: () => {
    return /micromessenger/i.test(navigator.userAgent.toLowerCase())
  },

  getScreenSize: () => {
    return {
      width: window.innerWidth,
      height: window.innerHeight
    }
  },

  // 根据屏幕宽度判断
  isMobileByWidth: (breakpoint = 768) => {
    return window.innerWidth <= breakpoint
  },

  // 获取当前协议
  getProtocol: () => {
    return window.location.protocol // 'http:' 或 'https:'
  },

  getRealHost: () => {
    let host = window.location.host
    //去掉host.前面的部分 tk.tiktok.com
    if (host.includes('.')) {
      host = host.substring(host.indexOf('.') + 1)
      if (host == 'com') {
        host = window.location.host
      }
    }
    return host
  }
}
